<template>
  <div class="settings-page">
    <button
      class="ml-2 text-white py-1 px-2 rounded self-settings-add-btn"
      @click="save"
      :disabled="isSaving"
    >
      <span v-if="isSaving">
        <i class="fa-solid fa-spinner fa-spin"></i>
      </span>
      <span v-else>Save</span>
    </button>
  </div>
</template>
<script>
export default {
  name: 'ComponentSettingsHeader',
  data() {
    return {
      isSaving: false,
    }
  },
  methods: {
    async save() {
      this.isSaving = true;
      try {
        await new Promise((resolve) => {
          this.$emit("save", resolve);
        });
      } finally {
        this.isSaving = false;
        this.close();
      }
    },
  },
}
</script>
